"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _color = _interopRequireDefault(require("color"));

var _ArrowRight = _interopRequireDefault(require("@p24/icons/ArrowRight"));

var _ArrowLeft = _interopRequireDefault(require("@p24/icons/ArrowLeft"));

function _default(palette) {
  var primary = (0, _color["default"])(palette.elAccent);
  var hoverColor;
  hoverColor = primary.rotate(2);
  hoverColor = (0, _color["default"])(hoverColor).saturate(0.3);
  hoverColor = (0, _color["default"])(hoverColor).darken(0.2);
  hoverColor = hoverColor.rgb().string();
  return {
    fontSize: palette.tsXSmall,
    borderRadius: '50%',
    incrementAppearance: _ArrowRight["default"],
    decrementAppearance: _ArrowLeft["default"],
    appearanceOpacity: palette.iconOpacity,
    appearanceOpacityHover: palette.iconOpacityHover,
    appearanceOpacityDisabled: palette.iconOpacityDisabled,
    idleColor: palette.tInactive,
    idleBackground: 'transparent',
    hoverBackground: 'transparent',
    hoverColor: palette.tFilled,
    selectedBackground: palette.elAccent,
    selectedColor: palette.tInversion,
    selectedHoverBackground: hoverColor,
    selectedHoverColor: palette.tInversion,
    width: 'auto',
    minWidth: 'auto'
  };
}